(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rz-collection-tabs')) {
    customElements.define(
      'rz-collection-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-tab]');
            if (!tab || event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            this.load(tab);
            this.querySelectorAll('[data-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
            this.querySelectorAll(':scope > [role="tabpanel"]').forEach((panel) => {
              panel.hidden = panel.id !== tab.getAttribute('aria-controls');
            });
          });
          // Start loading a tab as soon as the pointer or focus reaches it.
          const warm = (event) => {
            const tab = event.target.closest('[data-tab]');
            if (tab) this.load(tab);
          };
          this.addEventListener('pointerover', warm);
          this.addEventListener('focusin', warm);
        }

        // Hidden tabs arrive empty (data-lazy): fetch this section rendered for that tab and take its panel.
        load(tab) {
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
          if (!panel || !panel.hasAttribute('data-lazy') || panel.dataset.loading) return;
          panel.dataset.loading = 'true';
          fetch(`${location.pathname}?section_id=${this.dataset.sectionId}&page=${panel.dataset.tabIndex}`)
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((html) => {
              const source = new DOMParser().parseFromString(html, 'text/html').getElementById(panel.id);
              if (!source || source.hasAttribute('data-lazy')) throw new Error('tab not rendered');
              panel.replaceChildren(...source.childNodes);
              panel.removeAttribute('data-lazy');
            })
            .catch(() => {
              // No products to show here: fall back to the collection page if this tab is the open one.
              delete panel.dataset.loading;
              if (!panel.hidden && tab.href) location.href = tab.href;
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-icons-prev], [data-icons-next]');
    if (!arrow) return;
    const list = arrow.parentElement.querySelector('.icons-text__list');
    const step = arrow.hasAttribute('data-icons-next') ? list.clientWidth : -list.clientWidth;
    const end = list.scrollLeft + step;
    // Wrap around at either end, like the old slider.
    if (end > list.scrollWidth - list.clientWidth + 1) list.scrollTo({ left: 0, behavior: 'smooth' });
    else if (end < -1) list.scrollTo({ left: list.scrollWidth, behavior: 'smooth' });
    else list.scrollBy({ left: step, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rz-brands-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rz-brands-list')) {
    customElements.define(
      'rz-brands-list',
      class extends HTMLElement {
        connectedCallback() {
          const norm = (v) => (v || '').toLowerCase().trim().normalize('NFD').replace(/[̀-ͯ]/g, '');
          const index = this.querySelector('.brands__index--sticky');
          this.links = [...this.querySelectorAll('[data-index-link]')];
          this.groups = [...this.querySelectorAll('[data-group]')].map((el) => ({
            el,
            letter: el.dataset.group,
            items: [...el.querySelectorAll('[data-brand]')].map((li) => ({ el: li, text: norm(li.dataset.brand) })),
          }));

          // Sticky index: groups scroll in below it (the anchor jump itself is native; smooth via the CSS above).
          if (index) {
            this.links.forEach((a) =>
              a.addEventListener('click', () => this.style.setProperty('--brands-index-h', `${index.offsetHeight}px`))
            );
          }

          const input = this.querySelector('[data-search]');
          if (!input) return;
          let timer;
          const filter = () => {
            const q = norm(input.value);
            const active = new Set();
            let count = 0;
            this.groups.forEach((g) => {
              let shown = 0;
              g.items.forEach((i) => {
                i.el.hidden = q !== '' && !i.text.includes(q);
                if (!i.el.hidden) shown++;
              });
              g.el.hidden = shown === 0;
              if (shown) active.add(g.letter);
              count += shown;
            });
            this.links.forEach((a) => a.classList.toggle('is-disabled', !active.has(a.dataset.indexLink)));
            this.querySelector('[data-empty]').hidden = count !== 0;
            this.querySelector('[data-status]').textContent = `${count} ${this.dataset.resultsLabel}`;
          };
          input.addEventListener('input', () => {
            clearTimeout(timer);
            timer = setTimeout(filter, 120);
          });
          input.addEventListener('search', filter);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
